<template lang="pug">
	
	.menu
		.bg-layer
		.menu-wrapper
			close-button(:action="onTap")
			nav.nav
				ul.nav-wrapper
					li.nav-item 
						a(href="#" v-on:click="goTo($event,'youth')").nav-item-link {{translate('globals.sections.youth')}}
						.stripe
					li.nav-item 
						a(href="#" v-on:click="goTo($event,'proEra')").nav-item-link {{translate('globals.sections.pro_era')}}
						.stripe
					li.nav-item 
						a(href="#" v-on:click="goTo($event,'B4Da$$')").nav-item-link {{translate('globals.sections.badass')}}
						.stripe
					li.nav-item 
						a(href="#" v-on:click="goTo($event,'ameriKKKan')").nav-item-link {{translate('globals.sections.all_amerikkkan')}}
						.stripe
					li.nav-item 
						a(href="#" v-on:click="goTo($event,'landOfFree')").nav-item-link {{translate('globals.sections.land_of_free')}}
						.stripe
					li.nav-item 
						a(href="#" v-on:click="goTo($event,'racism')").nav-item-link {{translate('globals.sections.racism')}}
						.stripe
					li.nav-item 
						a(href="#" v-on:click="goTo($event,'engagement')").nav-item-link {{translate('globals.sections.engagement')}}
						.stripe

		

</template>

<script>
		
	import Vue from 'vue'
	import Component from 'vue-class-component'
	import $ from 'jquery'
	import { TweenMax } from 'gsap'
	import Scroller from '../utils/scroller.js'
	import Ticker from '../utils/ticker.js'
	import Section from '../abstracts/section'
	import CloseButton from '../controls/close-button.vue'
	
  @Component({
		name: 'Menu',
		components: { CloseButton }
	})

	class Menu extends Vue {

		mounted () {

			this._bind()
			this._on()
			this._dom() 
		}
		

		
		init () { }


		_dom () {
			this.$bg = this.$el.querySelector('.bg-layer')
			this.$menuItems = this.$el.querySelectorAll('.nav-item')
			this.$cross = this.$el.querySelector('.close-button')
		}

		_bind () {
			this.$events.on('menu.in',this.show.bind(this))
		}

		_on () {

		}

		onTap () {
			this.$events.emit('menu.out')
			this.hide()
		}

		show () {
			let tl = new TimelineMax()
			tl.set(this.$el,{display:'block'},0)
			tl.to(this.$bg,1,{opacity:1, ease:Expo.easeIn},0)
			tl.staggerTo(this.$menuItems,.6,{y:0,autoAlpha:1,ease: Expo.easeOut},.05,.8)
			tl.to(this.$cross,.6,{autoAlpha:1, ease: Power0.easeNone},1.2)
		}

		hide () {
			let tl = new TimelineMax()
			tl.to(this.$cross,.5,{autoAlpha:0, ease: Power0.easeNone})
			tl.staggerTo(this.$menuItems,.6,{y:100,autoAlpha:0, ease: Expo.easeIn},-.05,0)
			
			tl.to(this.$bg,1,{opacity:0,ease:Expo.easeIn},0)
			tl.set(this.$el,{display:'none'})
		}

		goTo (e,target) {
			e.preventDefault()
			this.$events.emit('app.anchor',target)
			this.$events.emit('menu.out')
			this.hide()
		}

		_resize () {
		}	

	}

	export default Menu

</script>


<style lang="stylus">
	
	@import '../theme/utils'
	@import '../theme/variables'
	
	.menu
		position fixed
		top 0
		left 0
		width 100vw
		height 100%
		z-index 90
		overflow hidden
		display none

		.bg-layer
			position absolute
			top 0
			right 0
			bottom 0
			left 0
			background-color #000
			z-index 10
			opacity 0


		.close-button
			opacity 0
			visibility hidden

		&-wrapper
			position relative
			z-index 40
			display flex
			flex-direction column
			align-items center
			padding-top 42px
			padding-bottom 20vh
			height 100%
			justify-content space-between
			
			.nav

				&-wrapper
					display flex
					flex-direction column
					align-items center
					height 55vh
					justify-content space-between

				&-item
					position relative
					visibility hidden
					opacity 0
					transform translateY(100px)

					.stripe
						position absolute
						top 2px
						left -2px
						width 0%
						height em(28px)
						background-color #0e19ee
						z-index 10
						transition width .5s cubic-bezier(0.190, 1.000, 0.220, 1.000)
					
					&-link
						color #fff
						text-decoration none
						text-transform uppercase
						font-family $FONT_SECONDARY
						font-weight 300
						font-size em(35px)
						letter-spacing .15em
						position relative
						z-index 30

					&:hover
						.stripe
							width 100%
		



</style>


// WEBPACK FOOTER //
// menu.vue?7bf8aedf